export const NEWSROOM_PROMO_ROUTE_PATH = 'newsroom';

export const BLOG_PROMO_ROUTE_PATH = 'learn/blog';

export const BRIDGER_STORIES_PROMO_ROUTE_PATH = 'learn/bridger-stories';
